<template>
    <tailwind-layout title="Application for Maintenance">
        <template #header>
            <div class="mb-4 px-4 sm:px-6 lg:px-8 mx-auto flex flex-col justify-between">
                <h1 class="font-semibold text-2xl leading-tight">Application for Maintenance</h1>
            </div>
        </template>

        <div class="overflow-hidden shadow-xl rounded-lg p-6 bg-white">
            <div class="">
                <h4 class="text-3xl text-left font-bold leading-7 text-gray-700 sm:text-2xl sm:truncate">
                    Terms and Conditions
                </h4>
                <form @submit.prevent="update" class="space-y-8 divide-y divide-gray-200">
                    <div class="space-y-8 divide-y divide-gray-200">
                        <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                            <div class="sm:col-span-6">
                                <terms-and-conditions-form :terms="terms" @scrolled-to-bottom="hasScrolledToBottom = true" />
                            </div>
                        </div>
                    </div>
                    <div class="py-5">
                        <div class="my-4">
                            <label>
                                <input type="checkbox" v-model="form.terms_and_conditions" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded" />
                                I Agree to the Terms and Conditions for the maintenance module
                            </label>
                        </div>
                        <p v-text="form.errors.terms_and_conditions" class="text-red-500 text-sm"></p>
                    </div>
                    <div class="pt-5 grid grid-cols-6 gap-4">
                        <div class="col-end-7 col-span-2 justify-end flex">
                            <inertia-link :href="route('login')" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Cancel</inertia-link>
                            <span class='has-tooltip ml-1'>
                                <span v-if="!form.terms_and_conditions" class='tooltip rounded shadow-lg p-2 bg-gray-100 text-grey-600 -mt-16 right-2'>You must agree to the Terms and Conditions before saving.</span>
                                <button type="submit" :disabled="!form.terms_and_conditions" :class="form.terms_and_conditions ? 'default': 'cursor-not-allowed'" class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 disabled:bg-indigo-300 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                    Submit
                                </button>
                            </span>
<!--                            <form-button :form="form" type="submit" :disabled="isDisabled">-->
<!--                                Save-->
<!--                            </form-button>-->
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </tailwind-layout>
</template>

<script>
import Icon from '@/Shared/Icon.vue'
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import FormButton from '@/Shared/FormButton.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import SelectInput from "@/Shared/SelectInput.vue"
import AlertCard from '@/Shared/AlertCard.vue'
import TermsAndConditionsForm from '@/Components/TermsAndConditions/TermsAndConditionsForm.vue'

export default {
    components: {
        Icon,
        TailwindLayout,
        FormButton,
        LoadingButton,
        SelectInput,
        AlertCard,
        TermsAndConditionsForm,
    },
    props: {
        terms: { type: String, default: null },
        version: { type: String, default: null },
    },
    remember: 'form',
    data() {
        return {
            hasScrolledToBottom: false,
            form: this.$inertia.form({
                terms_and_conditions: 0,
            }),
        }
    },
    methods: {
        update() {
            this.form.post(this.route('maintenance.update-terms-and-conditions'))
        },
        handleScroll: function(el) {
            if((el.srcElement.offsetHeight + el.srcElement.scrollTop) >= el.srcElement.scrollHeight) {
                this.hasScrolledToBottom = true;
            }
        }
    },
    computed: {
        isDisabled() {
            return (this.hasScrolledToBottom) ? false : true;
        },
    },
}
</script>
